import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-issue',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
	exact: true,
};
